import { render, staticRenderFns } from "./select_roles.vue?vue&type=template&id=31d254f0"
import script from "./select_roles.vue?vue&type=script&lang=js"
export * from "./select_roles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports